import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import { Grid } from '@mui/material';
import './guarantorCard.css';
import { IGuarantorCard } from './IGuarantorCard';


export default function GuarantorCard({
    status,
    title,
    id,
    icon,
    onClick,
    borderColor,
    color,
    backgroundColor,
}: IGuarantorCard) {
    return (
        <>
            <Grid
                className={borderColor != undefined ? borderColor : 'borderColorPrimaryColorLight-300'}
                style={{
                    border: '1.5px solid ',
                    height: '80px',
                    borderRadius: '5px',
                    background: '#fff',
                    alignContent: 'center',
                    marginTop: '10px',
                    backgroundColor: backgroundColor,
                }}
                container
                spacing={0}
            // onClick={() => onClick!()}
            >
                <Grid container item spacing={0} xs={10}>
                    {icon ? (
                        <div
                            style={{
                                display: 'inline-block',
                                marginRight: '20px',
                                alignSelf: 'center',
                            }}
                        >
                            {icon}
                        </div>
                    ) : null}
                    <div style={{ display: 'inline-block', marginRight: '15px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontSize: "14px", fontWeight: "bold" }} className={"text-sm " + (color != undefined ? color : "primaryColorLight-900")}>{title}</span>
                            <span className="font-normal text-xs primaryColorLight-100" style={{ float: "right", fontSize: "12.5px" }}>
                                {status}
                            </span>

                        </div>
                    </div>
                </Grid>
                <Grid item xs={2} className="leftSide" spacing={0}>
                    <ChevronLeftOutlinedIcon
                        className={color != undefined ? color : "primaryColorLight-100"}
                        style={{ width: '24px', height: '24px' }}
                    />
                </Grid>
            </Grid>
        </>
    );
}
